import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../integration-store';

export interface ICybersourceCredentials {
    merchant_id: string;
    api_key: string;
    api_secret: string;
}

class CybersourceCredentialsStore implements ICredentialsStore {
    private _changes: ICybersourceCredentials = {} as ICybersourceCredentials;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }

    public get merchant_id() { return this._changes.merchant_id; }
    public get api_key() { return this._changes.api_key; }
    public get api_secret() { return this._changes.api_secret; }

    public set merchant_id(value: string) { this._changes.merchant_id = value; }
    public set api_key(value: string) { this._changes.api_key = value; }
    public set api_secret(value: string) { this._changes.api_secret = value; }

    /********* ISaveable implementation *************/
    public hasChanges(): boolean {
        return !!Object.keys(this._changes).length;
    }

    public discardChanges(): void {
        this._changes = {} as ICybersourceCredentials;
    }

    public getUpdatedModel(): ICybersourceCredentials { throw new Error('Not implemented.'); }
    public isSaving(): boolean { throw new Error('Not implemented.'); }
    public commitChanges() { throw new Error('Not implemented.'); }
    public async save() { throw new Error('Not implemented.'); }

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default CybersourceCredentialsStore;